import React from "react";
import classNames from "classnames";
import classes from "./WaveLoader.scss";

const WaveLoader = ({ size = "sm", color = "#3b82f6", className = "" }) => {
  // Size mapping
  const sizeClasses = {
    sm: classes.sm,
    md: classes.md,
    lg: classes.lg,
    xl: classes.xl,
  };

  const sizeClass = sizeClasses[size] || sizeClasses.sm;

  return (
    <div className={classNames(classes.waveLoader, sizeClass, className)}>
      <div className={classes.waveBar} style={{ backgroundColor: color }}></div>
      <div className={classes.waveBar} style={{ backgroundColor: color }}></div>
      <div className={classes.waveBar} style={{ backgroundColor: color }}></div>
      <div className={classes.waveBar} style={{ backgroundColor: color }}></div>
      <div className={classes.waveBar} style={{ backgroundColor: color }}></div>
    </div>
  );
};

export default WaveLoader;
